

export const ColorPalette_NavigationBG_Light = {
    'blue'      : '#517BE6',
    'violet'    : '#7A5DCB',
    'green'     : '#1EA95F',
    'turquoise' : '#00A7CC',
    'dark'      : '#474B52',
    'gray'      : '#F7F8FA'
}

export const ColorPalette_NavigationBGDark_Light = { // border
    'blue'      : '#4168CF',
    'violet'    : '#664fae',
    'green'     : '#348f4d',
    'turquoise' : '#308eae',
    'dark'      : '#3c3f45',
    'gray'      : '#d0d1d3'
}

export const ColorPalette_NavigationSelected_Light = {
    'blue'      : '#4168CF',
    'violet'    : '#6848BF',
    'green'     : '#1B9C57',
    'turquoise' : '#0093B4',
    'dark'      : '#515459',
    'gray'      : '#ECf0F3'
}